import { render, staticRenderFns } from "./CustomerTasks.vue?vue&type=template&id=d32df320&scoped=true&"
import script from "./CustomerTasks.vue?vue&type=script&lang=js&"
export * from "./CustomerTasks.vue?vue&type=script&lang=js&"
import style0 from "./CustomerTasks.vue?vue&type=style&index=0&id=d32df320&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d32df320",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VChip,VCol,VDataTable,VIcon,VRow})
